/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_Event_GroupInputs */

const en_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new event group`)
};

const fr_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un nouveau groupe d’événements`)
};

const de_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisgruppe erstellen`)
};

const it_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un nuovo gruppo di eventi`)
};

const ru_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новую группу событий`)
};

const es_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nuevo grupo de eventos`)
};

const zh_cn2_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新事件组`)
};

const ja_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントグループを作成する`)
};

const hi_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट समूह बनाएं`)
};

const pt_pt2_create_new_event_group = /** @type {(inputs: Create_New_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar novo grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Create new event group" |
*
* @param {Create_New_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_new_event_group = /** @type {((inputs?: Create_New_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_create_new_event_group(inputs)
	if (locale === "de") return de_create_new_event_group(inputs)
	if (locale === "it") return it_create_new_event_group(inputs)
	if (locale === "ru") return ru_create_new_event_group(inputs)
	if (locale === "es") return es_create_new_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_create_new_event_group(inputs)
	if (locale === "ja") return ja_create_new_event_group(inputs)
	if (locale === "hi") return hi_create_new_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_create_new_event_group(inputs)
	return en_create_new_event_group(inputs)
});